import RadioTile, { RadioTileProps } from './RadioTile'
import { RadioTilesWrapper } from './styles'

export type RadioTileOptionType<T> = Omit<RadioTileProps<T>, 'name' | 'onClick'>

interface RadioTilesProps<T> {
  options: RadioTileOptionType<T>[]
  name: string
  onChange?: (val: RadioTileOptionType<T>['value']) => void
}

function RadioTiles<T extends string>({
  options,
  name,
  onChange,
}: RadioTilesProps<T>) {
  const handleClick = (val: RadioTileOptionType<T>['value']) => onChange?.(val)

  return (
    <RadioTilesWrapper optionsCount={options.length}>
      {options.map((opt, key) => (
        <RadioTile {...opt} name={name} key={key} onClick={handleClick} />
      ))}
    </RadioTilesWrapper>
  )
}

export default RadioTiles
